//eslint-disable-next-line @typescript-eslint/no-explicit-any
const format = (str: string, args?: any) => {
  //eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  for (const arg in args)
    str = str.replace(new RegExp(`\\{${arg}\\}`, 'gi'), args[arg])
  return str
}
export default format
